import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './app/store';
import App from './App';
import '@mantine/core/styles.css';
import { createTheme, MantineProvider } from '@mantine/core';

const theme = createTheme({
  fontFamily: 'Open Sans, sans-serif',
  headings: { fontFamily: 'Roboto, sans-serif' },
  lineHeight: 1.5,
  primaryColor: 'indigo',
  fontSizes: {
    xs: 20,
    sm: 22,
    md: 24,
    lg: 28,
    xl: 32,
    xxl: 36,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MantineProvider theme={theme}>
  <Provider store={store}>
    <App />
    </Provider>,
    </MantineProvider>
);